// Shared by the browser that sends the header (start.ts) and the gate that requires it on the
// server-fn path (api/app-session.server.ts). Two copies of the literal is one typo away from a gate
// that refuses every request from its own app.
export const APP_REQUEST_HEADER = 'x-vibe-app-request';
export const APP_REQUEST_HEADER_VALUE = '1';
